import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FirebaseService } from '../../networking/services/firebase/firebase.service';
import { FirebaseRemoteConfigEvent } from 'src/app/ui/shared/event-listeners/firebase-remote-config/firebase-remote-config.event';
import { FirebaseFlags } from '../../networking/models/firebase/response/flags';

@Injectable({
  providedIn: 'root'
})
export class FirebaseManager {

  constructor (
    private firebaseService: FirebaseService,
    private firebaseRemoteConfigEvent: FirebaseRemoteConfigEvent,
  ) {}

  getInitialRemoteConfig(): void {
    this.firebaseService.getInitialRemoteConfig();
  }

  getRemoteConfig(): Observable<FirebaseFlags> {
    return this.firebaseRemoteConfigEvent.get;
  }

}
